"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const ontario_design_system_component_library_react_1 = require("@ongov/ontario-design-system-component-library-react");
const LocationFooter = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ontario_design_system_component_library_react_1.OntarioFooter, { nonce: undefined, onResize: undefined, onResizeCapture: undefined, placeholder: undefined, onPointerEnterCapture: undefined, onPointerLeaveCapture: undefined, type: "default", footerLinks: {
            accessibilityLink: {
                text: 'Accessibility',
                href: t('locationFooter.accessibilityLink'),
            },
            privacyLink: {
                text: 'Privacy',
                href: t('locationFooter.privacyLink'),
            },
            contactLink: {
                text: 'Contact us',
                href: t('locationFooter.contactLink'),
            },
            printerLink: {
                text: "King's Printer for Ontario,",
                href: t('locationFooter.queensPrinterLink'),
            },
        } }));
};
exports.default = LocationFooter;
